import { checkboxColors } from './consts';
const baseStyle = {
    control: {
        color: checkboxColors.main,
        hoverColor: checkboxColors.hover
    }
};
const defaultProps = {
    size: 'md'
};
const parts = ['container', 'control', 'label'];
const sizes = {
    sm: {
        control: {
            h: 16,
            w: 16
        },
        label: {
            size: 'sm'
        }
    },
    md: {
        control: {
            h: 20,
            w: 20
        },
        label: {
            size: 'md'
        }
    },
    lg: {
        control: {
            h: 24,
            w: 24
        },
        label: {
            size: 'lg'
        }
    }
};
const variants = {};
export default {
    baseStyle,
    defaultProps,
    parts,
    sizes,
    variants
};
